import React from 'react';
import { Section, WhatsAppButton } from './Shared';
import { Search, FileSearch, TrendingUp, Check } from 'lucide-react';
export function Services() {
  const services = [{
    icon: Search,
    title: 'Diagnóstico Pensional Express',
    subtitle: 'El punto de partida para cualquier decisión pensional inteligente.',
    description: 'Tomamos tu historia laboral, la auditamos con tecnología actuarial y te entregamos:',
    deliverables: ['Proyección exacta de tu mesada en pesos colombianos reales.', 'Comparativa de regímenes: cuánto recibirías en Colpensiones vs tu fondo privado.', 'Detección de semanas faltantes en tu historial laboral.', 'Audio explicativo personalizado directo a tu WhatsApp.', 'PDF con tu hoja de ruta jurídica lista para ejecutar.'],
    footer: 'Tiempo de entrega: Inmediato. Precio: $149.000 COP — Un solo pago.'
  }, {
    icon: FileSearch,
    title: 'Auditoría Forense de Semanas',
    subtitle: 'Para quienes sospechan que el sistema no registró todo su tiempo trabajado.',
    description: 'Revisamos tu historia laboral período por período, identificamos cada bache y te entregamos:',
    deliverables: ['Reporte detallado de semanas faltantes con identificación de empleadores responsables.', 'Derecho de petición redactado y listo para radicar ante el fondo o Colpensiones.', 'Guía de documentos de respaldo para fortalecer tu reclamación.', 'Acompañamiento durante el proceso de recuperación.'],
    footer: 'Ideal para: Personas con más de 15 años de vida laboral que han trabajado en múltiples empresas o como independientes.'
  }, {
    icon: TrendingUp,
    title: 'Planificación Integral de Brecha Pensional',
    subtitle: 'Para profesionales de ingresos altos que necesitan más que una pensión básica.',
    description: 'Si ganas más de 4 salarios mínimos, tu pensión obligatoria no cubrirá tu estilo de vida actual. Este servicio calcula exactamente cuánto te faltará y diseña la estrategia para cerrarlo:',
    deliverables: ['Matriz actuarial de brecha pensional personalizada.', 'Análisis de fondos de pensiones voluntarias más rentables para tu perfil.', 'Estrategia de ahorro paralelo diseñada para tu ingreso y horizonte de retiro.', 'Optimización tributaria de aportes para reducir tu carga fiscal hoy.'],
    footer: 'Ideal para: Ejecutivos, independientes de altos ingresos y empresarios entre 35 y 55 años.'
  }];
  return <Section bg="slate" id="servicios" data-id="element-148">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-150">
          ¿Qué hacemos exactamente?
        </h2>
      </div>

      <div className="grid lg:grid-cols-3 gap-8" data-id="element-151">
        {services.map((service, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200 flex flex-col h-full" data-id="element-152">
            <div className="w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center mb-6 text-white" data-id="element-153">
              <service.icon className="w-6 h-6" data-id="element-154" />
            </div>

            <div className="mb-2 text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-155">
              Servicio {index + 1}
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-3" data-id="element-156">
              {service.title}
            </h3>
            <p className="text-slate-600 font-medium mb-4" data-id="element-157">
              {service.subtitle}
            </p>
            <p className="text-slate-600 text-sm mb-6" data-id="element-158">{service.description}</p>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-159">
              {service.deliverables.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-700" data-id="element-160">
                  <Check className="w-4 h-4 text-[#25D366] mt-0.5 flex-shrink-0" data-id="element-161" />
                  <span data-id="element-162">{item}</span>
                </li>)}
            </ul>

            <div className="bg-slate-50 p-4 rounded-lg mb-6 text-sm text-slate-700 font-medium border border-slate-100" data-id="element-163">
              {service.footer}
            </div>

            <WhatsAppButton text="Solicitar este servicio" fullWidth data-id="element-164" />
          </div>)}
      </div>
    </Section>;
}